// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Ro-z","imageAndVideoCount":"So-z","imageAndVideoContainer":"To-z","viewAllReviews":"Uo-z"};